// import logo from './logo.svg';
import { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes , Route, Outlet,useLocation } from "react-router-dom";
import Header from './components/Common/Header/Header';
import Footer from './components/Common/Footer/Footer';
import HomeRoute from './components/HomePage/HomeRoute';
import CommunityPage from './components/Community/CommunityPage';
import AlumniDirectoryPage from './components/Community/AlumniDirectory/AlumniDirectory';
import BusinessDirectoryPage from './components/Community/BusinessDirectory/BusinessDirectory';
import ViewBusinessListingPage from './components/Community/BusinessDirectory/ViewBusinessListing';
import JobsLandingPage from './components/Community/Jobs/JobsPage';
import ViewJobListingPage from './components/Community/Jobs/ViewJobsListing';
import PostLandingPage from './components/Community/Posts/PostPage';
import PostDetailingPage from './components/Community/Posts/PostDetailPage';
import ViewPostListingPage from './components/Community/Posts/ViewPostListing';
import EventPage from './components/Events/EventsPage';
import EventDetailPage from './components/Events/EventDetail';
import NewsPage from './components/News/News';
import NewsDeatilPage from './components/News/NewsDetail';
import AboutMayo from './components/AboutMayoPage/AbouMayoRoute';
import OfferPage from './components/Offers/OffersPage';
import ContactUSPage from './components/ContactUs/ContactUs';
import AbouMaadRoute from './components/AboutMaadPage/AbouMaadRoute';
import SecurityInformationPage from './components/Pages/SecurityInformation';
import RegulatoryInformationPage from './components/Pages/RegulatoryInformation';
import TermsConditionsPage from './components/Pages/TermsConditions';
import RefundPolicyPage from './components/Pages/RefundPolicy';
import PrivacyPolicyPage from './components/Pages/PrivacyPolicy';
import DisclaimerPage from './components/Pages/Disclaimer';
import RegistrationPage from './components/Registration/Registration';
// Login Dashboard
import DashboardHeader from './components/Dashboard/DashboardHeader';
import DashBoard from './components/Dashboard/DashBoardRoute';
import Membership from './components/Dashboard/DashBoardMembership';
import Donate from './components/Dashboard/Donate';
import BussinessListing from './components/Dashboard/BussinessListing';
import BusinessDirectoryCreate from './components/Dashboard/BusinessDirectoryCreate';
import JobListing from './components/Dashboard/JobsListing';
import MyJobsCreate from './components/Dashboard/Jobs/MyJobsCreate';
import MyOffer from './components/Dashboard/MyOffer';
import MyOfferCreate from './components/Dashboard/Offers/OfferCreate';
import PostListing from './components/Dashboard/PostListing';
import CreatePostListing from './components/Dashboard/Post/CreatePost';
import EventsListing from './components/Dashboard/EventsListing';
import EditProfile from './components/Dashboard/EditProfile';
import ChangePassword from './components/Dashboard/ChangePassword';
import  PrivateRoute  from './components/Dashboard/PrivateRoute';
import LoginPopup from './components/Common/Login/UserLogin';
import SearchResult from './components/Search/SearchResult';
import ResetPassword from './components/Common/Login/ResetPassword';
function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const DarkBackground = () =>{
    return(
      <div className="mainRoute">
          <Header />
          <Outlet/>
          <Footer />
          </div>)
  } 
  const DashBoardLoginHeader = () =>{
    return(
      <>
          <DashboardHeader />
          <Outlet/>
          <Footer />
          </>)
  }  
  // const PrivateRoute = ({ element }) => {
  //   const token = localStorage.getItem('token');
  //   return token ? element : <Navigate to="/" />;
  // };
  return (
    <Routes>
      <Route path='/' element={<DarkBackground />}>
        <Route path='' element={<HomeRoute />}></Route>
        <Route  path='/mayoalumni/:token' element={<ResetPassword />} />
        <Route path='/community' element={<CommunityPage />}></Route>
        <Route path='/alumni-directory' element={<AlumniDirectoryPage />}></Route>
        <Route path='/business-directories' element={<BusinessDirectoryPage />}></Route>
        <Route path='/view-business-listing' element={<ViewBusinessListingPage />}></Route>
        <Route path='/jobs' element={<JobsLandingPage />}></Route>
        <Route path='/view-jobs-listing' element={<ViewJobListingPage />}></Route>
        <Route path='/post' element={<PostLandingPage />}></Route>
        <Route path='/post-Detail/:url' element={<PostDetailingPage />}></Route>
        <Route path='/view-posts-listing' element={<ViewPostListingPage />}></Route>
        <Route path='/events' element={<EventPage />} ></Route>
        <Route path='/event-detail/:url' element={<EventDetailPage />}></Route>
        <Route path='/news' element={<NewsPage />}></Route>
        <Route path='/news-detail/:id' element={<NewsDeatilPage />}></Route>
        <Route path='/Home' element={<HomeRoute />}></Route>
        <Route path='/about-mayo' element={<AboutMayo />}></Route>
        <Route path='/offers'  element={<OfferPage />}></Route>
        <Route path='/contact' element={<ContactUSPage />}></Route>
        <Route path='/about-MAAD' element={<AbouMaadRoute />}></Route>
        <Route path='/security-information' element={<SecurityInformationPage />}></Route>
        <Route path='/regulatory-information' element={<RegulatoryInformationPage />}></Route>
        <Route path='/terms-conditions' element={<TermsConditionsPage />}></Route>
        <Route path='/refund-policy' element={<RefundPolicyPage/>}></Route>
        <Route path='/privacy-policy' element={<PrivacyPolicyPage />}></Route>
        <Route path='/disclaimer' element={<DisclaimerPage />}></Route>
        <Route path='/registration' element={<RegistrationPage />}></Route>
        <Route path='/login' element={<LoginPopup />}></Route>
        <Route path='/search' element={<SearchResult />} />
      </Route>
     
      <Route path='/' element={<DashBoardLoginHeader />}>
          <Route path='/dashboard' element={<PrivateRoute><DashBoard /></PrivateRoute>} />
          <Route path='/membership' element={<PrivateRoute><Membership /></PrivateRoute>} />
          <Route path='/donate' element={<PrivateRoute><Donate /></PrivateRoute>} />
          <Route path='/mybusinessdirectory' element={<PrivateRoute><BussinessListing /></PrivateRoute>} />
          <Route path='/business-directory-create' element={<PrivateRoute><BusinessDirectoryCreate /></PrivateRoute>} />
          <Route path='/myjobs' element={<PrivateRoute><MyJobsCreate /></PrivateRoute>} />
          <Route path='/myoffer' element={<PrivateRoute><MyOffer /></PrivateRoute>} /> 
          <Route path='/offer-create' element={<PrivateRoute><MyOfferCreate /></PrivateRoute>} /> 
          <Route path='/job-listing' element={<PrivateRoute><JobListing /></PrivateRoute>} /> 
          <Route path='/postListing' element={<PrivateRoute><PostListing /></PrivateRoute>} /> 
          <Route path='/post-create' element={<PrivateRoute><CreatePostListing /></PrivateRoute>} /> 
          <Route path='/myevent' element={<PrivateRoute><EventsListing /></PrivateRoute>} /> 
          <Route path='/edit-profile' element={<PrivateRoute><EditProfile /></PrivateRoute>} /> 
          <Route path='/change-password' element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
          <Route path='/login' element={<LoginPopup />}></Route>
        </Route>
    </Routes>
  );
}

export default App;
